import styles from '../styles/headers.module.scss';
import { ReactComponent as PlusIcon } from '@ui-kit/icons/plus.svg';
import { useHistory, useRouteMatch } from 'react-router-dom';

function TopicsListHeader() {
  const history = useHistory()
  const { url } = useRouteMatch()

  return (
    <div className={styles.mainHeader}>
      <div className={styles.header}>
        <div className={styles.info}>
          <button
            className={styles.btn}
            onClick={() => history.push(url.replace(/\/p-\d+/g,'') + '/create')}
          >
            <PlusIcon height={17} width={17} />
          </button>
          <p>topic</p>
        </div>
        <div className={styles.category}>replyes</div>
        <div className={styles.category}>posted</div>
      </div>
    </div>
  )
}

export default TopicsListHeader